import { createSlice } from '@reduxjs/toolkit'

const authSlice = createSlice({
  name: 'auth',
  initialState: {
    authenticating: null,
    error: null,
    problem: null,
    user: null,
    checked: false, // Indicador de que ya se verificó la sesión
  },
  reducers: {
    checkRequest: (state) => {
      return { ...state, authenticating: true, error: null, user: null, checked: false }
    },
    checkFinished: (state) => {
      return { ...state, authenticating: false, checked: true }
    },
    loginRequest: (state) => {
      return { ...state, authenticating: true, error: null, user: null }
    },
    loginSuccess: (state, { payload }) => {
      return { ...state, authenticating: false, error: null, user: payload, checked: true }
    },
    loginFailure: (state, { payload }) => {
      return { ...state, authenticating: false, error: true, problem: payload, user: null, checked: true }
    },
    logoutRequest: (state) => {
      return { ...state, authenticating: true, error: null }
    },
    logoutSuccess: (state) => {
      return { ...state, authenticating: false, error: null, user: null, checked: true }
    },
    logoutFailure: (state, { problem }) => {
      return { ...state, authenticating: false, error: true, problem }
    },
  },
})

export const AuthActions = authSlice.actions

export const AuthSelectors = {
  isAuthenticating: (state) => state.auth.authenticating,
  isAuthenticated: (state) => state.auth.user !== null,
  error: (state) => state.auth.error,
  problem: (state) => state.auth.problem,
  getUser: (state) => state.auth.user,
  checked: (state) => state.auth.checked,
}

export default authSlice.reducer
